<template>
  <section class="content map">

    <div v-if="map.message !== null"
         v-bind:class="'callout callout-'+map.message.type">
      <p>{{ map.message.text }}</p>
    </div>

    <div class="map-wrapper">

      <div class="map-filters row realtime" ref="elFilters">
        <div class="col-sm-3 col-md-3">
          <div class="row">
            <div class="form-group col-sm-12">
              <toggle-button
                :value="this.$store.state.map.realTimeMode"
                :sync="true"
                :labels="{checked: 'Tournées en cours', unchecked: 'Tournées terminées'}"
                :color="{checked: '#AADC14', unchecked: '#767C97'}"
                @change="toggleFilterTourneeInProgress"
                :height="35" :width="170"/>
            </div>
          </div>
        </div>
      </div>

      <gmap-map
        ref="map"
        v-if="mounted"
        :center="center"
        :zoom="13"
        map-type-id="roadmap"
        @center_changed="mapIsDirty = true"
        :style="mapStyle">

        <gmap-marker
          v-on:click="showInfoBulle"
          v-for="t in map.realTimeTournees"
          :icon="{ 'url' : 'static/img/tracker.svg' }"
          :position="{ 'lat' : t.latLastRemontee, 'lng' : t.lonLastRemontee }">

          <gmap-info-window :opened="infoWindowOpened" @closeclick="closeInfoBulle">
            <img class="top" v-bind:src="t.materiel_id | materielPictoV2" v-bind:alt="t.materiel_id | materielTypeV2">
            <div class="title">{{ t.materiel_id | materielTypeV2 }}</div>
            {{ t.materiel_id | materielName }}
            <br/><span class="time grey">vu à {{ t.dateLastRemontee | prettyDate }}</span><br/>
            <span class="time grey">{{ t.remonteeGPSs[t.remonteeGPSs.length-1].typeRemonteeGPS | remonteeType }}</span>
            <br>
            <div>
              <div v-if="!t.demandes">
                <a v-on:click="createNewDemande()"> Nouvelle demande </a>
              </div>
            </div>
          </gmap-info-window>
        </gmap-marker>

      </gmap-map>

    </div>

    <demande-modal title="Modifier une demande"
                   v-on:close="doCloseAnyModals"
                   v-if="updateModal === true">
      <demande-form slot="body"
                    v-on:close="doCloseAnyModals"
                    :update-demande="demande"></demande-form>
    </demande-modal>

    <demande-modal title="Créer une nouvelle demande"
                   v-on:close="doCloseAnyModals"
                   v-if="createModal === true">
      <demande-form slot="body"
                    v-on:close="doCloseAnyModals"></demande-form>
    </demande-modal>

  </section>
</template>

<script>
import {mapState} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import * as VueGoogleMaps from 'vue2-google-maps'
import DemandeModal from './commons/DemandeModal'
import DemandeForm from './demande/DemandeForm'

export default {
  components: {
    Datepicker,
    DemandeModal,
    DemandeForm,
  },
  data: function () {
    return {
      mounted: false,
      currentMidx: null,
      mapIsDirty: false,
      toggleValue: this.$store.state.map.realTimeMode,
      updateModal: false,
      createModal: false,
      demande: null,
      infoWindowOpened:true,
    }
  },
  computed: {
    ...mapState([
      'map',
      'demandesEnCours',
      'currentUser',
    ]),
    mapStyle: function () {
      const h = document.body.clientHeight - 80
      return 'width: 100%; height: ' + h + 'px'
    },
    center: function () {
      return {
        lat: this.$store.state.currentVille.coords.lat,
        lng: this.$store.state.currentVille.coords.lon
      }
    },
  },
  mounted: function () {
    this.$store.dispatch('fetchMaterielsOfVille')
    this.$store.dispatch('fetchCantonniersOfVille')
    this.mounted = true

    this.$store.dispatch('searchRealTimeTournees',{mode: this.$store.state.map.realTimeMode ? 'EN COURS' : 'TERMINEE' })
    var $t = this
    var start = null
    this.req = window.requestAnimationFrame(step)

    function step (timestamp) {
      console.log('Step')
      var progress
      if (start === null) start = timestamp
      progress = timestamp - start
      if (progress >= 10000) {
        $t.$store.dispatch('searchRealTimeTournees',{mode: $t.$store.state.map.realTimeMode ? 'EN COURS' : 'TERMINEE' })
        start = null
      }
      $t.req = window.requestAnimationFrame(step)
    }
  },
  destroyed: function () {
    if (this.req) {
      window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame
      window.cancelAnimationFrame(this.req)
    }
  },
  methods: {
    toggleFilterTourneeInProgress: function (event) {
      this.$store.state.map.realTimeMode = event.value
      this.$store.dispatch('searchRealTimeTournees', {mode: this.$store.state.map.realTimeMode ? 'EN COURS' : 'TERMINEE' })


      this.mapIsDirty = true
    },
    openDemandeDetails: function (demande) {
      this.demande = demande
      this.updateModal = true
      this.createModal = false
    },
    createNewDemande: function () {
      this.createModal = true
      this.updateModal = false
    },
    doCloseAnyModals: function () {
      this.updateModal = false
      this.createModal = false
    },
    showInfoBulle: function (){
      this.infoWindowOpened = true;
    },
    closeInfoBulle:function () {
      this.infoWindowOpened = false;
    },
  },
}
</script>

<style lang="scss">

@import '../../scss/variables';

.vue-map-container .vue-map {
  margin-top: 80px;
}

.demande-modal {
  height: 750px;
  width: 800px;
}

.map-wrapper {
  position: relative;

  .tournee-time {
    position: absolute;
    z-index: 10;
    top: 45px;
    left: 10px;
    background-color: white;
    padding: 10px;

    .time-item {
      text-transform: uppercase;
      line-height: 24px;
      height: 24px;

      .mapico {
        width: 16px;
        height: 16px;
        background-size: contain;
        background-repeat: no-repeat;
        display: inline-block;
        color: $suez-blue;

        &.debut {
          background-image: url('/static/img/debut-tournee.svg');
        }

        &.fin {
          background-image: url('/static/img/fin-tournee.svg');
        }

        &.pendule {
          background-image: url('/static/img/time.svg');
        }
      }
    }
  }
}

.content.map {
  height: 100%;
}


.vdp-datepicker.form-control {
  -webkit-appearance: menulist-button;
  -moz-appearance: menulist-button;
  appearance: menulist-button;
  width: 180px;
  padding: 0;
  margin: 0;

  input {
    border: none !important;
    padding: 5px;
    width: 160px;
    margin: 2px;
  }
}


.map-filters {
  position: absolute;
  z-index: 1000;
  width: 100%;

  & > div {
    vertical-align: top;
  }

  .row {
    margin: 0 -15px;
    border-radius: 0 0 5px 0;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 20px 15px;

    & > div + div {
      padding-left: 0
    }
  }

  .form-group {
    margin-bottom: 0;
  }

  .form-control {
    width: 100%;
    display: inline-block;
  }

  label {
    display: block;
  }

  label.vue-js-switch {
    font-size: 14px;
    display: inline-block;
    margin: 23px 0 0 0;

    .v-switch-label {
      color: $suez-blue;
      font-weight: normal;
      font-family: 'DinMedium';
    }
  }

  .switch {
    width: 100px;
    height: 54px;
    border-radius: 100px;
    background-color: #001051;
    box-shadow: 0 2px 4px 0 rgba(168, 168, 168, 0.2);
    cursor: pointer;
    float: right;

    div {
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      margin: 3px;
    }

    @mixin on() {
      width: 48px;
      height: 48px;
      border-radius: 40px;
      background-color: #ffffff;
      z-index: 1;
    }
    @mixin off() {
      width: 35px;
      height: 48px;
      border-radius: 40px;
      z-index: 5;
    }
  }

  @media screen and (max-width: 767px) {
    position: relative;
    z-index: 1;

    & > div, .row > div {
      display: block;
      float: none;
      clear: both;
      width: 100%;
      padding-left: 15px !important;
    }
    .row {
      background: none;
      padding-bottom: 0;
    }
    .form-group {
      padding-bottom: 15px;
    }
    label.vue-js-switch {
      margin-top: 0;
    }
    .switch {
      float: none;
      margin-left: 15px;
      margin-bottom: 20px;
    }
  }

  &.realtime {
    label.vue-js-switch {
      margin-top: 0 !important;
    }

    & > div {
      min-width: 230px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Realtime.vue?606f64d2